export default {
    editTitle: 'Редактировать шаблон',
};
